
import Button from './button';

interface ValidationAlertMessageProps {
    linkText: string
    fieldReference: any
    description: string
}

const ValidationAlertMessage = (props: ValidationAlertMessageProps) => {
    return <>
        <div key={`${props.linkText}-key`}>
            <Button
                color={'blue'}
                displayAs={'link'}
                onClick={() => props.fieldReference.focus()}
                style={{padding: 0}}
                analyticsDescription={'focus field'}
            >
                {props.linkText}
            </Button>: {props.description}
        </div>
    </>
};

export default ValidationAlertMessage;